export default __webpack_public_path__ + "static/media/Activity11.4440b7fe.jpeg";